<template>
    <div class="top-load-wrapper">
    <i class="iconfont" :class="{
        'icon-arrow-bottom': props.state === 'pull',
        'icon-arrow-bottom icon-arrow': props.state === 'trigger',
        'icon-loading': props.state === 'loading'
    }"></i>
    {{ props.stateText }}
    </div>
</template>

<script>
export default {
  name: 'PullToIcon',
  props: {
    props: {
      type: Object
    }
  }
}
</script>
